export const enum UserSignInViewStoreEvent {
  clickCreateAccount = 'click-create-account',
  clickForgotPassword = 'click-forgot-password',
  clickClose = 'click-close',
  clickSignInWithFacebook = 'click-signin-with-facebook',
  clickSignInWithGoogle = 'click-signin-with-google',
}
